// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file auth/add_user_data.proto (package app.dealzy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message app.dealzy.UpdateUserDataRequest
 */
export class UpdateUserDataRequest extends Message<UpdateUserDataRequest> {
  /**
   * @generated from field: int32 user_id = 1;
   */
  userId = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string email = 3;
   */
  email = "";

  /**
   * @generated from field: string address = 4;
   */
  address = "";

  /**
   * @generated from field: string pincode = 5;
   */
  pincode = "";

  constructor(data?: PartialMessage<UpdateUserDataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "app.dealzy.UpdateUserDataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "pincode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserDataRequest {
    return new UpdateUserDataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserDataRequest {
    return new UpdateUserDataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserDataRequest {
    return new UpdateUserDataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserDataRequest | PlainMessage<UpdateUserDataRequest> | undefined, b: UpdateUserDataRequest | PlainMessage<UpdateUserDataRequest> | undefined): boolean {
    return proto3.util.equals(UpdateUserDataRequest, a, b);
  }
}

